/**
 * List of possible uses for a contact point.
 */
export enum ContactPointUses {
  home = 'home',
  mobile = 'mobile',
  cx = '3cx',
  workOffice = 'workOffice',
  workMobile = 'workMobile',
  secured = 'secured',
  iot = 'iot',
  fax = 'fax',
}
export enum SystemEnum {
  phone = 'phone',
  email = 'email',
  fax = 'fax',
}
export enum OwnerType {
  organization = 'organization',
  person = 'person',
  place = 'place',
  practitioner = 'practitioner',
}

export const contactTypeDropdownData: any = {
  phone_3cx: '3CX',
  phone_home: 'Domicile',
  phone_iot: 'Appareil connecté',
  phone_mobile: 'Téléphone',
  email_secured: 'MSSanté',
  phone_workMobile: 'Téléphone',
  phone_workOffice: 'Fixe',
  email_workOffice: ' Email',
  email_home: 'Email',
  fax_workOffice: 'Fax',
}
/**
 * Identification of the entity owning the address
 */
export type Owner = {
  type: OwnerType
  id: string
}

/**
 * Details for all kinds of technology-mediated contact points for a person, or an organization, including telephone, email, etc.
 */

export type ContactPoint = {
  id?: string
  provider?: string | null
  system?: SystemEnum
  value?: string
  use?: ContactPointUses
  revision?: string
  createdAt?: Date
  updatedAt?: Date
  owner?: Owner
  disabled?: boolean
}
